import { Injectable, Inject } from '@angular/core';
import { LookupDataService } from '../http/lookupdata.service'
import { Observable, ReplaySubject, Subject } from 'rxjs';

@Injectable()
export class ArrayManipulations {

    getUniqueElements(list, uniqueKey) {
        const result = [];
        const map = new Map();
        for (const item of list) {
            if (item) {
                if (!map.has(item[uniqueKey])) {
                    map.set(item[uniqueKey], true);
                    result.push(item);
                }
            }
        }
        return result
    }

    isArrayIterable(data) {
        if (data && Array.isArray(data) && data.length > 0)
            return true
        else
            return false
    }

    deepCopy(o) {
        if (o)
            return JSON.parse(JSON.stringify(o));
        else
            return null
    }

    splitMulti(str, tokens = [], excludeTokens = []) {
        let presetTokens = ['/', ' ', '-', '(', ')', ',']
        if (Array.isArray(tokens)) {
            tokens.push(...presetTokens)
            if (Array.isArray(excludeTokens))
                tokens = tokens.filter(e => !excludeTokens.includes(e)) || []
        }
        var tempChar = tokens[0]; // We can use the first token as a temporary join character
        for (var i = 1; i < tokens.length; i++) {
            str = str.split(tokens[i]).join(tempChar);
        }
        str = str.split(tempChar);
        return str;
    }

    /**
     * Returns an array with arrays of the given size.
     *
     * @param myArray {Array} array to split
     * @param chunk_size {Integer} Size of every group
     */
    chunkArray(myArray, chunk_size) {
        var index = 0;
        var arrayLength = myArray.length;
        var tempArray = [];

        for (index = 0; index < arrayLength; index += chunk_size) {
            let myChunk = myArray.slice(index, index + chunk_size);
            // Do something if you want with the group
            tempArray.push(myChunk);
        }

        return tempArray;
    }

}